export const API_BASE_URL = process.env.REACT_APP_API_SERVER_URL;

export const languages = [
  {
    code: "en",
    name: "English",
  },
  {
    code: "he",
    name: "עברית",
    dir: "rtl",
  },
  {
    code: "ar",
    name: "عربى",
    dir: "rtl",
  },
];